// extracted by mini-css-extract-plugin
module.exports = {"container":"NoLogin_container__1PSkz","label":"NoLogin_label__3_fp1","handle":"NoLogin_handle__3BFSv","reason":"NoLogin_reason__2vvnm","content":"NoLogin_content__91uVR"};